/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class NoticeRoute extends Route {
  // Services
  @service
  notifications;

  @service
  store;

  model(params) {
    return hash({
      post: this.store.findRecord('posts/staffnotice', params.post_id, {
        include: 'reactions,comments',
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.notifications.markEntityRead(model.post.id);
  }
}
